import React from 'react';
import { Formik } from 'formik';

import LoginFormView from '../LoginFormView';

import { validateRequiredFields, validateEmailAddress } from 'utils/formValidations';

const LoginFormik = ({
    selectedView,
    setSelectedView,
    loginLoading,
    ssoLoginLoading,
    handleLogin,
    handleSSOLogin,
    agencyInfo,
}) => (
    <Formik
        initialValues={{
            email: '',
            password: '',
            rememberMe: false,
        }}
        validate={values => {
            return {
                ...validateRequiredFields(values, ['email', 'password']),
                ...validateEmailAddress(values, 'email')
            };
        }}
        onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            handleLogin(values);
        }}
    >
        {(props) =>
            <LoginFormView
                {...props}
                selectedView={selectedView}
                setSelectedView={setSelectedView}
                loginLoading={loginLoading}
                ssoLoginLoading={ssoLoginLoading}
                handleSSOLogin={handleSSOLogin}
                agencyInfo={agencyInfo}
            />
        }
    </Formik>
);

export default LoginFormik;
